import React, { useState } from 'react';
import styles from './CanCreateCase.module.scss';
import Text from '../../../BaseModule/Components/Text';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import { Theme } from '../../../BaseModule/Enums/Theme.enum';
import Button from '../../../BaseModule/Components/Button';
import apiClient from '../../../../Services/ApiClient';

interface Props {
	text1?: string;
	text2?: string;
	text3?: string;
	canChangeEmail: boolean;
	changeEmailButtonLabel?: string;
	userEmail: string;
}

const CanCreateCase: React.FC<Props> = ({
	text1,
	text2,
	text3,
	canChangeEmail,
	changeEmailButtonLabel,
	userEmail,
}) => {
	const [isEmailedSend, setIsEmailSend] = useState(false);
	const handleChangeEmail = () => {
		window.location.href = '/wizard/email_change';
	};

	const handleSendEmail = async () => {
		try {
			const response = await apiClient.post('/authentication/verify/email', {
				email: userEmail,
			});
			setIsEmailSend(response.status === 200);
		} catch (e) {
			console.log(e);
		}
	};

	let content = (
		<Button
			onClick={handleSendEmail}
			text='component.canCreateCase.sendAgainButton'
		/>
	);

	if (isEmailedSend) {
		content = (
			<>
				{text1 && <Text tx={text1} />}
				<div className={styles.email}>{userEmail}</div>
				{text2 && <Text tx={text2} />}
				{text3 && <Text tx={text3} />}
				{canChangeEmail && changeEmailButtonLabel && (
					<LinkButton
						text={changeEmailButtonLabel}
						theme={Theme.PURPLE}
						onClick={handleChangeEmail}
					/>
				)}
			</>
		);
	}

	return (
		<div className={styles.wrapper}>
			<Text className={styles.title} tx='component.canCreateCase.title' />
			{content}
		</div>
	);
};

export default CanCreateCase;
